import { render, staticRenderFns } from "./lanmao-load.vue?vue&type=template&id=afa8a4e4&scoped=true&"
import script from "./lanmao-load.vue?vue&type=script&lang=js&"
export * from "./lanmao-load.vue?vue&type=script&lang=js&"
import style0 from "./lanmao-load.vue?vue&type=style&index=0&id=afa8a4e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afa8a4e4",
  null
  
)

export default component.exports